import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  style?: React.CSSProperties;
}
export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  size = 'xl',
  style,
}) => (
  <div
    className={cn([
      'm-auto w-full px-4',
      'ea-container',
      {
        'ea-container--screen-sm max-w-screen-sm': size === 'sm',
        'ea-container--screen-md max-w-screen-md': size === 'md',
        'ea-container--screen-lg max-w-screen-lg': size === 'lg',
        'ea-container--screen-xl max-w-screen-xl': size === 'xl',
        'ea-container--screen-2xl max-w-screen-2xl': size === '2xl',
      },
      style,
      className,
    ])}
  >
    {children}
  </div>
);
